export function getManagerStatus() {
  const roles = window.localStorage.getItem('roles')

  if (roles && roles.indexOf('ADMIN') !== -1) {
    return true
  } else {
    return false
  }
}
